import { render } from "./ValidazioneFatture.vue?vue&type=template&id=5b7373aa&scoped=true"
import script from "./ValidazioneFatture.vue?vue&type=script&lang=js"
export * from "./ValidazioneFatture.vue?vue&type=script&lang=js"

import "./ValidazioneFatture.vue?vue&type=style&index=0&id=5b7373aa&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7373aa"]])

export default __exports__